import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

/**
 * Save a jsPDF document on both web and Capacitor native (Android/iOS).
 * On native, writes to Documents folder and opens it immediately.
 */
export const savePDF = async (doc, fileName) => {
  if (Capacitor.isNativePlatform()) {
    const base64Data = doc.output('datauristring').split(',')[1];
    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
      recursive: true,
    });
    try {
      await FileOpener.open({ filePath: result.uri, contentType: 'application/pdf' });
    } catch (_) {
      alert(`PDF saved:\n${fileName}\n\nOpen it from your Files app.`);
    }
  } else {
    doc.save(fileName);
  }
};
